import { render, staticRenderFns } from "./tableModule.vue?vue&type=template&id=c908aa0e&scoped=true&"
import script from "./tableModule.vue?vue&type=script&lang=ts&"
export * from "./tableModule.vue?vue&type=script&lang=ts&"
import style0 from "./tableModule.vue?vue&type=style&index=0&id=c908aa0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c908aa0e",
  null
  
)

export default component.exports